export const POSTAL_CODE: RegExp = /^[A-Za-z][0-9][A-Za-z][ ]?[0-9][A-Za-z][0-9] *$/;
export const ZIP_CODE: RegExp = /^\d{5}(?:\d{2})?$/;
